export enum Roles {
    SysAdmin = 'SysAdmin',
    WealthService = 'WealthService',
    HumanResources = 'HumanResources',
    BusinessIntelligence = 'BusinessIntelligence',
    Asset = 'Asset',
    BackRvd = 'BackRvd',
    PerformanceAndProjects = 'PerformanceAndProjects',
    Ipo = 'Ipo',
    Cambio = 'Cambio',
    FinancialPlanning = 'FinancialPlanning',
    Consolidation = 'Consolidation',
}
